import { injectIntl } from 'react-intl'
import { LOCALIZED_MESSAGES } from './messages'
import { MenuButtonIcon } from 'spa/components/menu_button_icon'
import { Popover } from 'spa/components/popover'
import { VersionButtonIcon } from 'spa/components/version_button_icon'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles'

function TablePopover({
  buttonClassName,
  buttonIcon,
  buttonText,
  caretColor,
  children,
  className = '',
  contentClassName = '',
  fixed = false,
  handleGetCoords,
  intl,
  setIsOpen,
  ...rest
}) {
  return (
    <Popover
      className={className}
      closeOnScroll={false}
      contentClassName={contentClassName}
      fixed={fixed}
      renderTrigger={({ handleClick, open, ref }) => (
        <>
          <button
            className={classNames(
              'cleanButton',
              styles.tablePopoverButton,
              buttonClassName,
              {
                [styles.buttonMargin]: buttonIcon === 'sort-down',
                [styles.downloadButton]: buttonIcon === 'arrow-alt-circle-down',
                [styles.activeButton]: open,
              }
            )}
            onClick={e => {
              handleClick()
              handleGetCoords ? handleGetCoords(e) : null
            }}
            ref={ref}
            tooltip={
              buttonIcon === 'ellipsis-h'
                ? intl.formatMessage(LOCALIZED_MESSAGES.moreOptionsTooltip)
                : buttonIcon === 'arrow-alt-circle-down'
                ? intl.formatMessage(LOCALIZED_MESSAGES.getSongTooltip)
                : ''
            }
          >
            {buttonText || null}
            {buttonIcon ? (
              <VersionButtonIcon
                className={styles.popoverTriggerIcon}
                icon={buttonIcon}
                isVertical={buttonIcon === 'ellipsis-h' ? open : null}
                style={caretColor ? { color: caretColor } : null}
              />
            ) : (
              <MenuButtonIcon isOpen={open} />
            )}
          </button>
        </>
      )}
      setIsOpen={setIsOpen}
      {...rest}
    >
      {children}
    </Popover>
  )
}

const LocalizedTablePopover = injectIntl(TablePopover)
export { LocalizedTablePopover as TablePopover }

TablePopover.propTypes = {
  buttonClassName: PropTypes.string,
  buttonIcon: PropTypes.string,
  buttonText: PropTypes.node,
  caretColor: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  fixed: PropTypes.bool,
  handleGetCoords: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  setIsOpen: PropTypes.func,
}
